import { motion } from "framer-motion";
import { Logo } from "./Logo";
import { PLAY_URL } from "./config";

export const Navbar = () => (
  <motion.header
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
    className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/50 backdrop-blur-xl"
    data-testid="navbar"
  >
    <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
      <a
        href="#top"
        data-testid="nav-logo-link"
        className="flex items-center gap-3"
      >
        <Logo size={34} />
        <span className="font-accent text-lg font-bold tracking-[0.25em] text-[#EAEAEA]">
          IRONCREST
        </span>
      </a>
      <nav className="hidden items-center gap-10 md:flex">
        <a
          href="#features"
          data-testid="nav-features-link"
          className="text-sm text-[#A3A3A3] transition-colors duration-300 hover:text-[#D4AF37]"
        >
          The Realm
        </a>
        <a
          href="#gallery"
          data-testid="nav-gallery-link"
          className="text-sm text-[#A3A3A3] transition-colors duration-300 hover:text-[#D4AF37]"
        >
          Glimpse
        </a>
        <a
          href={PLAY_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-play-button"
          className="font-accent rounded-full border border-[#D4AF37]/40 px-5 py-2 text-xs font-semibold tracking-widest text-[#D4AF37] transition-colors duration-300 hover:bg-[#D4AF37] hover:text-black"
        >
          COMING SOON
        </a>
      </nav>
    </div>
  </motion.header>
);
